/**
 * DSS Animation Normalizers — normalize animation/transition values
 */

import type { DssAnimation } from "@ease/page-builder";

export function getLegacyAnimationProps(animation: DssAnimation | undefined): Record<string, string> {
  if (!animation) return {};
  const props: Record<string, string> = {};
  if (animation.entranceType && animation.entranceType !== "none") {
    props.animationType = animation.entranceType;
    props.animationDelay = String(animation.delayMs ?? 0);
    props.animationDuration = String(animation.durationMs ?? 400);
  }
  if (animation.transition) props.transition = animation.transition;
  if (animation.transform) props.transform = animation.transform;
  return props;
}
